import { UtilsEnum } from '@/utils/UtilsEnum';

/** @type {EnumType<
 * 'CSV' |
 * 'PDF'
 * >}
 */
export const OPCOES_EXPORTACAO = UtilsEnum.create({
  CSV: { value: 'CSV', description: 'CSV' },
  PDF: { value: 'PDF', description: 'PDF' },
});
